interface SectionHeaderProps {
  eyebrow?: string;
  title: string;
  description?: string;
  linkText?: string;
  linkHref?: string;
}

export default function SectionHeader({
  eyebrow,
  title,
  description,
  linkText,
  linkHref,
}: SectionHeaderProps) {
  return (
    <div className="mb-8 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {eyebrow && (
          <div className="mb-2 flex items-center gap-2 text-sm font-medium text-accent-600">
            <span className="inline-block h-1.5 w-6 rounded-full bg-accent-500"></span>
            {eyebrow}
          </div>
        )}
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {description && (
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            {description}
          </p>
        )}
      </div>
      {linkText && linkHref && (
        <a
          href={linkHref}
          className="group inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-background-100 px-4 py-2 text-sm font-medium text-foreground-700 transition hover:bg-primary-500 hover:text-background-50"
        >
          {linkText}
          <i className="ri-arrow-right-line text-base transition group-hover:translate-x-0.5"></i>
        </a>
      )}
    </div>
  );
}